import React from 'react';
import { SearchIcon } from 'lucide-react';
export const PotentialFilters = () => {
  return <div className="bg-white p-6 rounded-lg shadow mb-6" data-id="element-615">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-616">
        <div className="relative lg:col-span-2" data-id="element-617">
          <input type="text" placeholder="Buscar por nombre o identificación..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-618" />
          <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-619" />
        </div>
        <div data-id="element-620">
          <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-621">
            <option value="" data-id="element-622">Rango de Monto</option>
            <option data-id="element-623">Menos de $1,000</option>
            <option data-id="element-624">$1,000 - $5,000</option>
            <option data-id="element-625">$5,000 - $10,000</option>
            <option data-id="element-626">Más de $10,000</option>
          </select>
        </div>
        <div data-id="element-627">
          <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-628">
            <option value="" data-id="element-629">Estado</option>
            <option data-id="element-630">Pendiente</option>
            <option data-id="element-631">En Revisión</option>
            <option data-id="element-632">Aprobado</option>
            <option data-id="element-633">Rechazado</option>
          </select>
        </div>
      </div>
    </div>;
};